const Breadcrumbs = () => (
    Component($context => (
        $context.select('.breadcrumbs')
    ), ($breadcrumbs, self) => {
        const breadcrumbs_plugin = window.elkitorg_breadcrumbs_plugin;

        $.extend(self, {
            initBrothers: function ($btn) {
                const dataDrop = $btn.attr('data-drop');

                if (dataDrop !== undefined) {
                    return $(dataDrop);
                }

                const $breadcrumb = $btn.closest('.breadcrumbs__item');
                const index = $breadcrumb.index();
                let breadcrumb = breadcrumbs_plugin.breadcrumbs[index];

                if (index === breadcrumbs_plugin.breadcrumbs.length) {
                    breadcrumb = breadcrumbs_plugin.current_page_item;
                }

                if (!breadcrumb) {
                    return $();
                }

                var $dropdown = $('<div class="breadcrumbs__brothers-dropdown" tabindex="0"></div>');
                var $dropdownList = $('<div class="breadcrumbs__brothers-dropdown-list"></div>')

                breadcrumb.brothers.forEach(function (brother) {
                    var $brother = $('<a class="breadcrumbs__brother c-link"></a>');
                    $brother.text(brother.name);
                    $brother.attr('href', brother.frontend_url);
                    $dropdownList.append($brother);
                });

                $dropdown.append($dropdownList);
                $btn.attr('data-drop', $dropdown.prop('outerHTML'))

                return $dropdown

            },
            initEventListeners: function () {
                if (!breadcrumbs_plugin) {
                    return;
                }

                let eventAdd = 'click'
                let eventRemove = 'blur';

                if (breadcrumbs_plugin.show_subcategories_on_hover) {
                    eventAdd = 'click mouseenter';
                    eventRemove = 'blur mouseleave'
                }

                const $brotherButton = $breadcrumbs.find('.breadcrumbs__brothers-button');

                function onEventRemove(e) {
                    const relatedTarget = e.relatedTarget;
                    const isChildRelatedTarget = relatedTarget !== null
                        && relatedTarget.closest('.breadcrumbs__brothers-dropdown') === this;

                    if (isChildRelatedTarget) {
                        return;
                    }

                    const $dropdown = $(this);
                    $dropdown.removeClass('breadcrumbs__brothers-dropdown_open');
                    setTimeout(() => {
                        $dropdown.remove();
                        $brotherButton.removeClass('breadcrumbs__brothers-button_open');
                    }, 200)
                }

                $brotherButton.on(eventAdd, function () {
                    const $btn = $(this);

                    if ($btn.hasClass('breadcrumbs__brothers-button_open')) {
                        $('.breadcrumbs__brothers-dropdown').trigger('blur');
                        return;
                    }

                    const $dropdown = self.initBrothers($btn)

                    if (!$dropdown.length) {
                        return;
                    }

                    $btn.addClass('breadcrumbs__brothers-button_open');

                    const {top, left} = $btn.offset();
                    const containerWidth = Math.round($btn.closest('.breadcrumbs__item-container').width());

                    $dropdown.attr('style', `top:${top + $btn.outerHeight()}px; 
                    left:${left - containerWidth}px; 
                    --container-width: ${containerWidth}px;`);

                    $dropdown.appendTo('body');
                    $dropdown.focus();
                    $dropdown.on(eventRemove, onEventRemove);
                    $dropdown.addClass('breadcrumbs__brothers-dropdown_open');
                });
            }
        });

        self.initEventListeners();
    })
);

export default Breadcrumbs;